import Phaser from 'phaser';

/**
 * Straight-line projectile. No gravity, no drop-off. Despawns only when it
 * leaves the camera or hits something — the first thing it touches dies
 * instantly (the GameScene applies the kill, not the bullet itself).
 */
export class Bullet extends Phaser.Physics.Arcade.Sprite {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'bullet');
    scene.add.existing(this);
    scene.physics.add.existing(this);
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setAllowGravity(false);
    // Hitbox covers the star head only, not the trail, so collisions feel honest.
    body.setSize(5, 5);
    body.setOffset(9, 1);
    this.setBlendMode(Phaser.BlendModes.ADD);
  }

  fire(x: number, y: number, dir: -1 | 1, speed = 700) {
    this.enableBody(true, x, y, true, true);
    this.setActive(true).setVisible(true);
    this.setVelocityX(dir * speed);
    this.setVelocityY(0);
    this.setFlipX(dir < 0);
    // Streak trail behind the bullet.
    const trail = this.scene.add
      .image(x, y, 'bullet')
      .setBlendMode(Phaser.BlendModes.ADD)
      .setAlpha(0.6)
      .setDepth(this.depth - 1);
    this.scene.tweens.add({
      targets: trail,
      alpha: 0,
      scaleX: 0.3,
      duration: 180,
      onComplete: () => trail.destroy(),
    });
  }

  /** Despawn: hide + disable so the pool can recycle. */
  kill() {
    this.disableBody(true, true);
    this.setActive(false).setVisible(false);
  }
}
